export const PAGE_BREAK_NODE_NAME = 'page-break';
